import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getManagerPanel } from '../../services/migration/personnelDataService';

export interface ManagerBankPermissions {
  canTransact: boolean;
  canCreditCards: boolean;
  canTransfer: boolean;
  loaded: boolean;
}

const NONE: ManagerBankPermissions = { canTransact: false, canCreditCards: false, canTransfer: false, loaded: false };

/** Kural backend'deki ManagerPanelPermissions.IsGranted(bank_transactions / bank_creditCards / bank_transfers) ile aynıdır. */
export const resolveBankPermissions = (settings: any): Omit<ManagerBankPermissions, 'loaded'> => {
  const s = settings || {};
  const subs = s['bank_subPermissions'] || {};
  const bankOpen = s['bank'] === true;
  return {
    canTransact: bankOpen && subs['bank_transactions'] === true,
    canCreditCards: bankOpen && subs['bank_creditCards'] === true,
    canTransfer: bankOpen && subs['bank_transfers'] === true,
  };
};

/** Şube yöneticisinin Banka alt yetkileri. `enabled` false ise istek atılmaz. */
export const useManagerBankPermissions = (enabled: boolean): ManagerBankPermissions => {
  const { currentUser } = useAuth();
  const [perms, setPerms] = useState<ManagerBankPermissions>(NONE);

  useEffect(() => {
    if (!enabled || !currentUser?.uid) {
      setPerms(NONE);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const mp = await getManagerPanel(currentUser.uid);
        if (cancelled) return;
        setPerms({ ...resolveBankPermissions(mp.found ? mp.settings : null), loaded: true });
      } catch (e) {
        console.warn('[useManagerBankPermissions] managerPanel okunamadı:', e);
        if (!cancelled) setPerms({ ...NONE, loaded: true });
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, currentUser?.uid]);

  return perms;
};
